export class Cerca {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    nome: string;
    tipo: string; //circular/poligonal
    raio: number;
    latitude: number;
    longitude: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/shared/cerca.model.ts
 **/